// menuConfig.js
import { Home, Users, FileText, PawPrint, MapPin, CreditCard, Settings, Stethoscope, Briefcase } from "lucide-react";

export const petAdminMenu = [
  { label: "Admin Panel", path: "/swift-app/admin/adminPanel", icon: Home },
  { label: "User Management", path:'/swift-app/admin/users', icon: Users },
  { label: "Consultation", path: "/swift-app/admin/consultation", icon: Stethoscope },
  { label: "Services", path: "/swift-app/admin/services", icon: Briefcase },
  { label: "Blogs & Community", path: "/swift-app/admin/blogsCommunity", icon: FileText },
  { label: "Pet Finder", path: "/swift-app/admin/pet-finder", icon: PawPrint },
  { label: "Pet Places", path: "/swift-app/admin/pet-places", icon: MapPin },
  { label: "Payments", path: "/swift-app/admin/payments", icon: CreditCard },
  { label: "Settings", path: "/swift-app/admin/settings", icon: Settings },
];
